(() => {
  "use strict";

  if (window.__ATC_UNIFIED_ACTIVE) return;
  window.__ATC_UNIFIED_ACTIVE = true;

  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const escapeSelector = (value) =>
    window.CSS && CSS.escape
      ? CSS.escape(value)
      : String(value).replace(/(["'\\#:[\].,=\s])/g, "\\$1");
  const sanitizePropertyValue = (value) =>
    String(value || "")
      .replace(/[<>]/g, "")
      .trim();
  const debugPaidOption = (...args) => {
    void args;
  };
  const feeProductCache = new Map();

  function getCartUI() {
    return document.querySelector("cart-drawer") || document.querySelector("cart-notification") || null;
  }

function warmImageUrl(url) {
    if (!url) return;

    const image = new Image();
    image.decoding = "async";

    try {
      image.fetchPriority = "high";
    } catch (_) {}

    image.src = url;
  }

  function getSelectedProductImageUrl(form) {
    const context = getFormContext(form.getAttribute("id") || "");
    const image =
      context.querySelector("media-gallery .product__media-item.is-active img") ||
      context.querySelector(".product__media-item.is-active img") ||
      context.querySelector(".product__media img") ||
      context.querySelector(".product__media-wrapper img");

    return image?.currentSrc || image?.src || "";
  }

  function setButtonLoading(button) {
    if (!button) return;

    button.classList?.add("loading");
    button.setAttribute("disabled", "disabled");
    button.setAttribute("aria-busy", "true");

    const spinner = button.querySelector(".loading__spinner, .loading-overlay__spinner, .loading-spinner");
    if (spinner) {
      spinner.classList.remove("hidden", "visually-hidden");
      spinner.removeAttribute("hidden");
      spinner.removeAttribute("aria-hidden");
      spinner.style.display = "";
      spinner.style.visibility = "";
      spinner.style.opacity = "";
    }
  }

  function clearButtonLoading(button) {
    if (!button) return;

    button.classList?.remove("loading");
    button.removeAttribute("disabled");
    button.setAttribute("aria-busy", "false");

    const spinner = button.querySelector(".loading__spinner, .loading-overlay__spinner, .loading-spinner");
    if (spinner) {
      spinner.classList.add("hidden", "visually-hidden");
      spinner.setAttribute("hidden", "");
      spinner.setAttribute("aria-hidden", "true");
      spinner.style.removeProperty("display");
      spinner.style.removeProperty("visibility");
      spinner.style.removeProperty("opacity");
    }
  }

  function getFormContext(formId) {
    const form = document.getElementById(formId);
    return (
      form?.closest("section, .product, .shopify-section, modal-dialog, quick-add-modal, product-modal, dialog, .modal, .quick-add-modal") ||
      document
    );
  }

  function getFirstEnabledOption(select) {
    for (let i = 0; i < select.options.length; i += 1) {
      if (!select.options[i].disabled) return select.options[i];
    }
    return null;
  }

  function getPackRoot(formId) {
    return (
      document.querySelector(`pack-hyperflow[data-product-form-id="${escapeSelector(formId)}"]`) ||
      getFormContext(formId).querySelector("pack-hyperflow")
    );
  }

  function hasUpsells(formId) {
    return (
      !!document.querySelector(`.product-upsell[data-product-form-id="${escapeSelector(formId)}"]`) ||
      !!getFormContext(formId).querySelector(".product-upsell")
    );
  }

  function hasPack(formId) {
    return !!document.querySelector(`pack-hyperflow[data-product-form-id="${escapeSelector(formId)}"]`) || !!getPackRoot(formId);
  }

  function getPaidOptionRoots(formId) {
    const roots = new Set();
    const selector = `[data-hf-paid-option][data-product-form-id="${escapeSelector(formId)}"]`;

    $$(selector).forEach((root) => roots.add(root));
    $$("[data-hf-paid-option]", getFormContext(formId)).forEach((root) => {
      if (!root.dataset.productFormId || root.dataset.productFormId === formId) {
        roots.add(root);
      }
    });

    const result = Array.from(roots);
    debugPaidOption("roots", {
      formId,
      selector,
      context: getFormContext(formId),
      directCount: $$(selector).length,
      contextCount: $$("[data-hf-paid-option]", getFormContext(formId)).length,
      count: result.length,
      roots: result.map((root) => ({
        tag: root.tagName,
        className: root.className,
        productFormId: root.dataset.productFormId || "",
        feeVariantId: root.dataset.feeVariantId || "",
        feeOptionLabel: root.dataset.feeOptionLabel || "",
        feeProductTitle: root.dataset.feeProductTitle || "",
      })),
    });
    return result;
  }

  function hasPaidOptions(formId) {
    return getPaidOptionRoots(formId).length > 0;
  }

  function getPaidOptionValue(root) {
    const fields = $$("input, select, textarea", root).filter((field) => {
      const name = field.getAttribute("name") || "";
      return name.startsWith("properties[");
    });

    debugPaidOption("read option value", {
      feeVariantId: root.dataset.feeVariantId || "",
      label: root.dataset.feeOptionLabel || "",
      fields: fields.map((field) => ({
        tag: field.tagName,
        type: field.getAttribute("type") || "",
        name: field.getAttribute("name") || "",
        value: field.type === "file" ? Array.from(field.files || []).map((file) => file.name) : field.value,
        checked: field.checked,
        disabled: field.disabled,
      })),
    });

    for (const field of fields) {
      const tagName = field.tagName;
      const type = String(field.getAttribute("type") || "").toLowerCase();

      if ((type === "checkbox" || type === "radio") && field.checked) {
        debugPaidOption("value matched", {
          type,
          name: field.getAttribute("name") || "",
          value: field.value || "Oui",
        });
        return field.value || "Oui";
      }

      if (type === "file") {
        const files = Array.from(field.files || []).filter((file) => file && file.name);
        if (files.length) {
          debugPaidOption("value matched", {
            type,
            name: field.getAttribute("name") || "",
            value: files.map((file) => file.name).join(", "),
          });
          return files.map((file) => file.name).join(", ");
        }
      }

      if (tagName === "SELECT") {
        const selectedOption = field.options ? field.options[field.selectedIndex] : null;
        if (selectedOption && !selectedOption.disabled && field.value) {
          debugPaidOption("value matched", {
            type: "select",
            name: field.getAttribute("name") || "",
            value: field.value,
          });
          return field.value;
        }
      }

      if (type !== "checkbox" && type !== "radio" && type !== "file" && tagName !== "SELECT") {
        const value = String(field.value || "").trim();
        if (value) {
          debugPaidOption("value matched", {
            type,
            name: field.getAttribute("name") || "",
            value,
          });
          return value;
        }
      }
    }

    debugPaidOption("no active value", {
      feeVariantId: root.dataset.feeVariantId || "",
      label: root.dataset.feeOptionLabel || "",
    });
    return "";
  }

  function generatePaidOptionGroupId() {
    if (window.crypto?.randomUUID) {
      return `hf-custom-${window.crypto.randomUUID()}`;
    }

    return `hf-custom-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }

  async function resolveFeeVariantId(root) {
    const configuredVariantId = Number(root.dataset.feeVariantId || 0);
    if (configuredVariantId) return configuredVariantId;

    const handle = String(root.dataset.feeProductHandle || "").trim();
    if (!handle) return 0;

    if (feeProductCache.has(handle)) {
      return feeProductCache.get(handle);
    }

    const rootUrl = String(window.Shopify?.routes?.root || "/");
    const productUrl = `${rootUrl.replace(/\/$/, "")}/products/${encodeURIComponent(handle)}.js`;

    debugPaidOption("resolve fee product", {
      handle,
      productUrl,
    });

    try {
      const response = await fetch(productUrl, {
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        debugPaidOption("resolve fee product failed", {
          handle,
          status: response.status,
        });
        feeProductCache.set(handle, 0);
        return 0;
      }

      const product = await response.json();
      const variant = Array.isArray(product.variants)
        ? product.variants.find((item) => item && item.available !== false)
        : null;
      const variantId = Number(variant?.id || 0);

      feeProductCache.set(handle, variantId);
      debugPaidOption("resolve fee product result", {
        handle,
        variantId,
        productTitle: product.title || "",
        available: !!variantId,
      });

      return variantId;
    } catch (error) {
      debugPaidOption("resolve fee product error", {
        handle,
        error,
      });
      feeProductCache.set(handle, 0);
      return 0;
    }
  }

  async function getPaidOptionItems(formId, quantity) {
    const roots = getPaidOptionRoots(formId);
    const unavailableFeeProducts = [];
    const items = (
      await Promise.all(
        roots.map(async (root) => {
          const optionValue = getPaidOptionValue(root);
          if (!optionValue) return null;

          const variantId = await resolveFeeVariantId(root);

          debugPaidOption("build fee item candidate", {
            variantId,
            quantity,
            optionValue,
            label: root.dataset.feeOptionLabel || "",
            feeProductTitle: root.dataset.feeProductTitle || "",
          });

          if (!variantId) {
            unavailableFeeProducts.push(root.dataset.feeProductTitle || root.dataset.feeProductHandle || "Produit de frais");
            return null;
          }

          return {
            id: variantId,
            quantity,
            properties: {
              _hf_custom_fee: "true",
              _hf_custom_fee_option: root.dataset.feeOptionLabel || "Option personnalisée",
              _hf_custom_fee_value: sanitizePropertyValue(optionValue),
            },
          };
        })
      )
    ).filter(Boolean);

    debugPaidOption("fee items", {
      formId,
      quantity,
      count: items.length,
      items,
      unavailableFeeProducts,
    });

    return {
      items,
      unavailableFeeProducts,
    };
  }

  function getMainProductItem(form) {
    const formData = new FormData(form);
    const variantId = Number(formData.get("id"));
    const quantity = Number(formData.get("quantity") || 1);

    if (!variantId) return null;

    const item = {
      id: variantId,
      quantity,
    };

    const sellingPlan = formData.get("selling_plan");
    if (sellingPlan) {
      item.selling_plan = sellingPlan;
    }

    const properties = {};
    formData.forEach((value, key) => {
      if (key.startsWith("properties[")) {
        properties[key.slice(11, -1)] = value;
      }
    });

    if (Object.keys(properties).length) {
      item.properties = properties;
    }

    return item;
  }

  function getPackItems(formId) {
    const packRoot = getPackRoot(formId);
    if (!packRoot) return [];

    const selectedPack = $(".pack__wrapper component-pack.pack__selected", packRoot);
    if (!selectedPack) return [];

    const packQuantity = parseInt(selectedPack.dataset.quantity || "1", 10) || 1;

    let selectedVariants = Array.isArray(selectedPack.selectedVariants)
      ? selectedPack.selectedVariants.filter((variant) => variant && variant.id && variant.available !== false)
      : [];

    if (!selectedVariants.length) {
      const selectContainers = $$(".pack__select--container", selectedPack);

      if (selectContainers.length) {
        const variantsTemplate = packRoot.querySelector("#pack-hyperflow-variants");
        const variantOptions =
          variantsTemplate && variantsTemplate.content
            ? Array.from(variantsTemplate.content.querySelectorAll("option")).map((option) => ({
                title: option.getAttribute("data-option") || "",
                id: Number(option.getAttribute("data-id")),
                available: option.getAttribute("data-available") === "true",
              }))
            : [];

        selectContainers.forEach((container) => {
          const values = Array.from(container.querySelectorAll("select")).map((select) => select.value);
          if (!values.length) return;

          const match = variantOptions.find((variant) => variant.available && variant.title === values.join(" / "));
          if (match && match.id) {
            selectedVariants.push({
              id: match.id,
              available: true,
            });
          }
        });
      }
    }

    if (!selectedVariants.length) {
      const fallbackVariantId =
        (() => {
          const variantsTemplate = packRoot.querySelector("#pack-hyperflow-variants");
          if (!variantsTemplate || !variantsTemplate.content) return 0;

          const firstAvailable = Array.from(variantsTemplate.content.querySelectorAll("option")).find(
            (option) => option.getAttribute("data-available") === "true"
          );

          return firstAvailable ? Number(firstAvailable.getAttribute("data-id")) : 0;
        })() || Number(packRoot.getAttribute("data-product-id") || 0);

      return fallbackVariantId
        ? [
            {
              id: fallbackVariantId,
              quantity: packQuantity,
              properties: { _pack: "true" },
            },
          ]
        : [];
    }

    const grouped = {};
    selectedVariants.forEach((variant) => {
      grouped[variant.id] = (grouped[variant.id] || 0) + 1;
    });

    return Object.keys(grouped).map((id) => ({
      id: Number(id),
      quantity: grouped[id],
      properties: { _pack: "true" },
    }));
  }

  function getUpsellItems(formId) {
    const upsellRoot =
      $(`.product-upsell[data-product-form-id="${escapeSelector(formId)}"]`) ||
      $(".product-upsell", getFormContext(formId));

    if (!upsellRoot) return [];

    const items = [];

    $$(".product-upsell__option", upsellRoot).forEach((option) => {
      const radio = option.querySelector(".product-upsell__radio-input");
      if (!radio || !radio.checked) return;

      const nativeSelector = option.querySelector(".product-upsell__selector--native");
      let variantId = 0;

      if (nativeSelector) {
        let selectedOption = nativeSelector.options[nativeSelector.selectedIndex];
        if (!selectedOption || selectedOption.disabled) {
          selectedOption = getFirstEnabledOption(nativeSelector);
          if (!selectedOption) return;
          nativeSelector.value = selectedOption.value;
        }
        variantId = Number(selectedOption.value);
      } else {
        variantId = Number(radio.dataset.variantUpsellId || 0);
      }

      if (!variantId) return;

      items.push({
        id: variantId,
        quantity: 1,
        properties: { _upsell: "true" },
      });
    });

    return items;
  }

  function mergeItems(items) {
    const map = new Map();

    (items || []).forEach((item) => {
      const key = `${item.id}|${item.selling_plan || ""}|${JSON.stringify(item.properties || {})}`;
      if (map.has(key)) {
        map.get(key).quantity += item.quantity;
      } else {
        map.set(key, { ...item });
      }
    });

    return Array.from(map.values());
  }

  function getSectionsToRender() {
    const cartUI = getCartUI();

    if (cartUI && typeof cartUI.getSectionsToRender === "function") {
      const sections = cartUI
        .getSectionsToRender()
        .map((section) => section.id)
        .filter(Boolean);

      if (!sections.includes("cart-icon-bubble") && document.getElementById("cart-icon-bubble")) {
        sections.push("cart-icon-bubble");
      }

      return sections;
    }

    const sections = [];
    if (document.querySelector("cart-drawer")) sections.push("cart-drawer");
    if (document.querySelector("cart-notification")) sections.push("cart-notification");
    if (document.getElementById("cart-icon-bubble")) sections.push("cart-icon-bubble");

    return sections;
  }

  function updateCartBubble(sections) {
    if (!sections || !sections["cart-icon-bubble"]) return;

    const bubble = document.getElementById("cart-icon-bubble");
    if (!bubble) return;

    const parsed = new DOMParser().parseFromString(sections["cart-icon-bubble"], "text/html");
    const newBubble = parsed.getElementById("cart-icon-bubble");
    if (newBubble) {
      bubble.innerHTML = newBubble.innerHTML;
    }
  }

  function closeOpenModalFrom(node) {
    const directModal =
      node?.closest?.("modal-dialog, quick-add-modal, product-modal, details[open], .modal, .quick-add-modal") || null;

    let candidates = [];
    if (directModal) candidates.push(directModal);

    candidates = candidates.concat(
      Array.from(
        document.querySelectorAll(
          "modal-dialog[open], quick-add-modal[open], product-modal[open], dialog[open], details.quick-add-modal[open], .modal.is-open, .quick-add-modal.is-open"
        )
      )
    );

    const closedModals = [];
    let closed = false;

    candidates.forEach((modal) => {
      try {
        if (typeof modal.hide === "function") {
          modal.hide();
          closed = true;
          closedModals.push(modal);
          return;
        }

        if (modal.tagName === "DIALOG" && typeof modal.close === "function") {
          modal.close();
          closed = true;
          closedModals.push(modal);
          return;
        }

        if (modal.hasAttribute?.("open")) {
          modal.removeAttribute("open");
          closed = true;
          closedModals.push(modal);
        }

        modal.classList?.remove("is-open", "open");
      } catch (_) {}
    });

    if (!closed) {
      const closeButton = document.querySelector(
        '[data-close-modal], .modal__close-button, button[aria-label="Close"], button[aria-label="Fermer"]'
      );

      if (closeButton) {
        try {
          closeButton.click();
          closed = true;
        } catch (_) {}
      }
    }

    if (closed) {
      document.documentElement.classList.remove("overflow-hidden");
      document.body.classList.remove("overflow-hidden");
    }

    return closedModals;
  }

  function openCartUI() {
    const cartUI = getCartUI();

    if (!cartUI) {
      const cartType = window.theme?.cartType || 'drawer';
      if (cartType === 'page') {
        const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
        window.location.assign(cartUrl);
      }
      return;
    }

    if (typeof cartUI.open === "function") {
      cartUI.open();
      return;
    }

    cartUI.classList.add("is-open");
    document.documentElement.classList.add("overflow-hidden");
  }

  document.addEventListener(
    "click",
    (event) => {
      const submitButton = event.target.closest('form[data-type="add-to-cart-form"] [type="submit"]');
      if (!submitButton) return;

      const form = submitButton.closest("form");
      if (!form) return;

      const formId = form.getAttribute("id") || "";
      if (!formId) return;

      if (hasUpsells(formId) || hasPack(formId) || hasPaidOptions(formId)) {
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === "function") {
          event.stopImmediatePropagation();
        }
      }
    },
    true
  );

  document.addEventListener(
    "submit",
    async (event) => {
      const form = event.target.closest('form[data-type="add-to-cart-form"]');
      if (!form) return;

      const formId = form.getAttribute("id") || "";
      if (!formId) return;

      const formHasUpsells = hasUpsells(formId);
      const formHasPack = hasPack(formId);
      const formHasPaidOptions = hasPaidOptions(formId);

      debugPaidOption("submit", {
        formId,
        formHasUpsells,
        formHasPack,
        formHasPaidOptions,
        form,
      });

      if (!(formHasUpsells || formHasPack || formHasPaidOptions)) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === "function") {
        event.stopImmediatePropagation();
      }

      if (form.__atcLock) return;
      form.__atcLock = true;

      const submitButton = form.querySelector('[type="submit"]');
      setButtonLoading(submitButton);

      const packItems = formHasPack ? getPackItems(formId) : [];
      const upsellItems = formHasUpsells ? getUpsellItems(formId) : [];
      const mainItem = packItems.length ? null : getMainProductItem(form);
      const paidOptionResult = !packItems.length && mainItem
        ? await getPaidOptionItems(formId, mainItem.quantity)
        : {
            items: [],
            unavailableFeeProducts: [],
          };
      const paidOptionItems = paidOptionResult.items;

      if (paidOptionResult.unavailableFeeProducts.length) {
        const message = `Le produit de frais "${paidOptionResult.unavailableFeeProducts[0]}" n'est pas disponible en stock.`;

        debugPaidOption("abort: unavailable fee product", {
          message,
          unavailableFeeProducts: paidOptionResult.unavailableFeeProducts,
        });

        try {
          publish(PUB_SUB_EVENTS.cartError, {
            source: "atc-unified",
            productVariantId: mainItem?.id || "",
            errors: message,
            message,
          });
        } catch (_) {}

        const productForm = form.closest("product-form");
        if (productForm && typeof productForm.handleErrorMessage === "function") {
          productForm.handleErrorMessage(message);
        } else {
          const errorWrapper = form.querySelector(".product-form__error-message-wrapper");
          const errorMessage = errorWrapper?.querySelector(".product-form__error-message");
          if (errorWrapper && errorMessage) {
            errorMessage.textContent = message;
            errorWrapper.removeAttribute("hidden");
          }
        }

        clearButtonLoading(submitButton);
        form.__atcLock = false;
        return;
      }

      debugPaidOption("items before grouping", {
        packItems,
        upsellItems,
        mainItem,
        paidOptionItems,
      });

      if (mainItem && paidOptionItems.length) {
        const groupId = generatePaidOptionGroupId();
        mainItem.properties = mainItem.properties || {};
        mainItem.properties._hf_custom_group_id = groupId;
        paidOptionItems.forEach((item) => {
          item.properties._hf_custom_group_id = groupId;
        });
        debugPaidOption("group assigned", {
          groupId,
          mainItem,
          paidOptionItems,
        });
      }

      const selectedImageUrl = !packItems.length && mainItem ? getSelectedProductImageUrl(form) : "";
      if (selectedImageUrl) {
        warmImageUrl(selectedImageUrl);
      }

      const successMode = window.HFAtcFeedback && window.HFAtcFeedback.isSuccessMode();

      const cartUI = getCartUI();

      let items = [];
      if (packItems.length) {
        items = items.concat(packItems);
      } else if (mainItem) {
        items.push(mainItem);
      }

      if (upsellItems.length) {
        items = items.concat(upsellItems);
      }

      if (paidOptionItems.length) {
        items = items.concat(paidOptionItems);
      }

      if (!items.length) {
        debugPaidOption("abort: no items");
        clearButtonLoading(submitButton);
        form.__atcLock = false;
        return;
      }

      const mergedItems = mergeItems(items);
      const payload = new FormData();

      debugPaidOption("merged items", mergedItems);

      mergedItems.forEach((item, index) => {
        payload.append(`items[${index}][id]`, item.id);
        payload.append(`items[${index}][quantity]`, item.quantity);

        if (item.selling_plan) {
          payload.append(`items[${index}][selling_plan]`, item.selling_plan);
        }

        if (item.properties) {
          Object.keys(item.properties).forEach((key) => {
            payload.append(`items[${index}][properties][${key}]`, item.properties[key]);
          });
        }
      });

      const sections = getSectionsToRender();
      if (sections.length) {
        payload.append("sections", sections.join(","));
      }
      payload.append("sections_url", window.location.pathname);

      let addUrl = "/cart/add.js";
      if (window.routes && window.routes.cart_add_url) {
        addUrl = String(window.routes.cart_add_url).replace(/\/cart\/add(\?.*)?$/, "/cart/add.js$1");
      }

      debugPaidOption("request", {
        addUrl,
        sections,
        payload: Array.from(payload.entries()),
      });

      fetch(addUrl, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: payload,
      })
        .then((response) =>
          response.json().then((data) => ({
            ok: response.ok,
            data,
          }))
        )
        .then((result) => {
          debugPaidOption("response", result);
          if (!result.ok || result.data.status) {
            const message = result.data?.description || result.data?.message || "Erreur lors de l'ajout au panier.";

            debugPaidOption("response error details", {
              status: result.data?.status || "",
              message: result.data?.message || "",
              description: result.data?.description || "",
              errors: result.data?.errors || "",
            });

            try {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "atc-unified",
                productVariantId: mergedItems[0]?.id || "",
                errors: result.data?.errors || result.data?.description || message,
                message,
              });
            } catch (_) {}

            if (window.HFAtcFeedback) {
              window.HFAtcFeedback.showError(submitButton);
            }

            const productForm = form.closest("product-form");
            if (productForm && typeof productForm.handleErrorMessage === "function") {
              productForm.handleErrorMessage(message);
            } else {
              const errorWrapper = form.querySelector(".product-form__error-message-wrapper");
              const errorMessage = errorWrapper?.querySelector(".product-form__error-message");
              if (errorWrapper && errorMessage) {
                errorMessage.textContent = message;
                errorWrapper.removeAttribute("hidden");
              }
            }

            return;
          }

          if (result.data.sections) {
            updateCartBubble(result.data.sections);
          }

          if (successMode) {
            const drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.refreshContents === 'function') {
              drawer.refreshContents(result.data);
            } else if (window.HFAtcFeedback && result.data.sections) {
              window.HFAtcFeedback.updateCartBubble(result.data.sections);
            }
            if (window.HFAtcFeedback) {
              window.HFAtcFeedback.showSuccess(submitButton);
            }
            return;
          }

          const currentCartUI = getCartUI();
          if (currentCartUI && typeof currentCartUI.refreshContents === "function") {
            try { currentCartUI.refreshContents(result.data); } catch (_) {}
          } else if (currentCartUI && typeof currentCartUI.renderContents === "function") {
            try { currentCartUI.renderContents(result.data); } catch (_) {}
          }

          if (currentCartUI?.classList?.contains("is-empty")) {
            currentCartUI.classList.remove("is-empty");
          }

          const closedModals = closeOpenModalFrom(form);

          const proceedToCart = () => {
            try {
              document.body.dispatchEvent(new CustomEvent("cart:refresh"));
              document.body.dispatchEvent(new CustomEvent("cart:open"));
            } catch (_) {}
            openCartUI();
          };

          const waitForModalClose = closedModals.find((m) =>
            m && (m.tagName === 'QUICK-ADD-MODAL' || m.matches?.('quick-add-modal, modal-dialog, .quick-add-modal'))
          );

          if (waitForModalClose) {
            let done = false;
            const finish = () => {
              if (done) return;
              done = true;
              proceedToCart();
            };
            waitForModalClose.addEventListener('transitionend', finish, { once: true });
            setTimeout(finish, 450);
          } else {
            proceedToCart();
          }
        })
        .catch((error) => {
          debugPaidOption("request failed", error);
        })
        .finally(() => {
          clearButtonLoading(submitButton);
          form.__atcLock = false;
        });
    },
    true
  );
})();
